module.exports = __webpack_public_path__ + "img/logo_4.c1b7aaa5.png";